import type { SegmentType } from '@rcs/data-schema';
import { SEGMENT_STYLES, SEGMENT_STYLE_ORDER } from '../course/segment-style';
import { messages } from '../i18n/ja';
import { useMovableWindow } from '../layout/movable';

/**
 * 3D ビューの枕木の色分けの凡例。コースにある区間の種類だけを、色・アイコン・文言で示す
 * （色だけに頼らない）。
 */
export function SegmentLegend({ kinds }: { readonly kinds: readonly SegmentType[] }) {
  const t = messages.segmentLegend;
  const present = SEGMENT_STYLE_ORDER.filter((kind) => kinds.includes(kind));
  const {
    attach: windowAttach,
    style: windowStyle,
    handle: windowHandle,
  } = useMovableWindow<HTMLDivElement>('legend', messages.windows.names.legend);
  if (present.length === 0) return null;
  return (
    <div ref={windowAttach} className="segment-legend" style={windowStyle}>
      {windowHandle}
      <ul className="segment-legend__list" aria-label={t.label} data-testid="segment-legend">
        {present.map((kind) => {
          const style = SEGMENT_STYLES[kind];
          return (
            <li key={kind} data-kind={kind}>
              <span
                className="segment-legend__swatch"
                style={{ background: style?.css }}
                aria-hidden="true"
              />
              <span aria-hidden="true">{style?.icon}</span> {t.kinds[kind]}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
